<template>
    <div class="list-item">
        <header class="list-item-header">
            <div class="list-item-title">
                <img src="../../../assets/repair/repair-name-img.png" alt="">
                <strong>{{dataInfo.orgName}}-{{dataInfo.aptName}}</strong>
            </div>
            <div class="list-item-time">
                <div>
                    <img src="../../../assets/repair/time.png" alt="">
                    <div>报修:{{dataInfo.openTime}}</div>
                </div>
                <div>
                    <img src="../../../assets/repair/time.png" alt="">
                    <div>完成:{{dataInfo.closeTime}}</div>
                </div>
            </div>
        </header>

        <main class="list-item-main">
            <div class="list-item-row">
                <img :src="getImg" alt="">
                <div>{{dataInfo.itemName}}</div>
            </div>
            <div>{{dataInfo.description}}</div>
        </main>

        <footer class="list-item-footer">
            <div class="list-item-progress" v-if="getIsShowProgress">
                <div class="list-item-progress-value"><div :style="{width: getProgress}"></div></div>
                <div class="list-item-progress-name">
                    <div>等待受理</div>
                    <div>维修中</div>
                    <div>已完成</div>
                </div>
            </div>

            <div class="list-item-star" v-else>
                <div>满意评价</div>
                <el-rate  v-model="value"></el-rate>
            </div>
        </footer>
    </div>
</template>

<script>
    import utils from "./Utils";
    import axios from "axios";
    import {Message} from 'element-ui';

    export default {
        name: "ListItem",

        props: {
            dataInfo: {}
        },

        data() {
            return {
                value: "",

                isCreate: true
            }
        },

        created() {
            this.value = this.dataInfo.score + "";
        },

        watch: {
            value() {
                if (!this.isCreate) {
                    this.commitStar();
                }
                else {
                    this.isCreate = false;
                }
            }
        },

        methods: {
            commitStar() {
                axios({
                    method: 'post',
                    url: "/api/v1/renter/reports/score",
                    headers: {'Authorization': this.$route.query.token},
                    data: {
                        "workOrderID": this.dataInfo.workOrderID,
                        "score": parseInt(this.value)
                    }
                }).then(value => {
                    if (value.data.code !== 0) {
                        Message.error(value.data.message);
                    }
                    else {
                        Message.success("感谢您的评价");
                    }
                }).catch((err) => {
                    Message.error(err.toString());
                });
            }
        },

        computed: {
            getProgress() {
                if (this.dataInfo.progress === "等待受理") {
                    return "20%";
                }
                else  if (this.dataInfo.progress === "维修中") {
                    return "55%";
                }
                return "0%"
            },

            getIsShowProgress() {
                return this.dataInfo.progress !== "已完成";
            },

            getImg() {
                return utils.getImg(this.dataInfo.itemName);
            }
        }

    }
</script>

<style scoped lang="scss">
    @import "../pay/page";

    .list-item {
        margin: 14px auto 0;
        width: 90%;

        .list-item-header {
            box-sizing: border-box;
            border-radius: 10px 10px 0 0;
            padding: 10px;
            background-color: white;
            border-bottom: 1px $fontColor-9 dotted;

            .list-item-title {
                align-items: center;
                color: $fontColor-3;
                box-sizing: border-box;
                height: 44px;
                display: flex;
                img {
                    margin-right: 10px;
                    height: 25px;
                    width: 25px;
                }
            }
            .list-item-time {
                display: flex;
                >div {
                    width: 50%;
                    font-size: 13px;
                    color: $fontColor-9;
                    align-items: center;
                    display: flex;
                }
                img {
                    margin-right: 5px;
                    height: 18px;
                    width: 18px;
                }
            }
        }

        .list-item-main {
            color: $fontColor-9;
            box-sizing: border-box;
            border-radius: 0 0 10px 10px;
            padding: 10px;
            background-color: white;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            .list-item-row {
                background-color: white;
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 33%;
                min-width: 33%;
                img {
                    margin-top: 10px;
                    width: 60%;
                }
            }
        }

        .list-item-footer {
            box-sizing: border-box;
            border-radius: 10px;
            padding: 10px;
            background-color: #F7F7F7;

            .list-item-progress {
                box-sizing: border-box;
                padding: 10px;
                .list-item-progress-name {
                    margin-top: 14px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    color: $fontColor-9;
                }
                .list-item-progress-value {
                    border-radius: 50px;
                    width: 100%;
                    height: 10px;
                    background: $bgColor;
                    div {
                        border-radius: 50px;
                        height: 10px;
                        background: $colorDefault;
                    }
                }
            }

            .list-item-star {
                color: $fontColor-9;
                padding-left: 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

        }
    }

</style>
